import { setObjects } from '../helpers';

const initialState = () => ({
    current: null, /*{
        firstname: 'Floor',
        middlename: 'van',
        lastname: 'Steeg',
    }*/
    storage: {},
})

const mutations = {
    SET_CURRENT_USER (state, user) {
        setObjects([user], state.storage, { groups: [] }) // makes sure properties are merged
        // TODO: replace with just id, then let getter resolve user object
        state.current = state.storage[user.id]
    },
    SET_CURRENT_USER_GROUPS (state, groups) {
        state.current.groups = groups
    },
    ADD_USERS (state, users) {
        setObjects(users, state.storage, { groups: [] })
    }
}

export default {
    initialState,
    state: initialState(),
    mutations
}



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/users.js